import { LANDING_ASSETS } from './landingDesignAssets';

export const HOW_IT_WORKS_EYEBROW = 'Explore the app';
export const HOW_IT_WORKS_HEADLINE = 'Run every customer conversation from one AI app.';

export const HOW_IT_WORKS_STEPS = [
  {
    n: '01',
    navLabel: 'Owner Copilot',
    kicker: 'OWNER COPILOT CHAT',
    title: 'Talk to Linas.',
    body: 'Tell Linas what changed. It updates the right business knowledge and confirms what was saved — no forms.',
    points: [
      { icon: 'chat', title: 'Tell Linas' },
      { icon: 'check', title: 'Confirm' },
      { icon: 'save', title: 'Saved' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.ownerCopilot,
    alt: 'Owner Copilot chat in Linas AI',
  },
  {
    n: '02',
    navLabel: 'Side Menu',
    kicker: 'SIDE MENU',
    title: 'Find everything fast.',
    body: 'Start a new chat, open any app section or return to recent conversations from one place.',
    points: [
      { icon: 'menu', title: 'Open' },
      { icon: 'select', title: 'Choose' },
      { icon: 'arrow', title: 'Continue' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.sideMenu,
    alt: 'Linas AI side menu',
  },
  {
    n: '03',
    navLabel: 'Dashboard',
    kicker: 'DASHBOARD',
    title: 'See what matters. Act faster.',
    body: 'Track messages, customer replies, requests, and channel performance in one clear view.',
    points: [
      { icon: 'calendar', title: 'Choose dates' },
      { icon: 'compare', title: 'Compare' },
      { icon: 'check', title: 'Decide' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.dashboard,
    alt: 'Linas AI activity dashboard',
  },
  {
    n: '04',
    navLabel: 'AI Setup',
    kicker: 'AI SETUP',
    title: 'Teach every detail.',
    body: 'Review and edit the knowledge Linas uses: languages, tone, services, products, hours and policies.',
    points: [
      { icon: 'select', title: 'Complete' },
      { icon: 'eye', title: 'Review' },
      { icon: 'send', title: 'Publish' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.aiSetup,
    alt: 'AI Setup progress in Linas AI',
  },
  {
    n: '05',
    navLabel: 'Smart Answers',
    kicker: 'SMART ANSWERS / Q&A',
    title: 'Save trusted answers.',
    body: 'Save trusted Q&A once, translate it to chosen languages and reuse it for similar questions. Matched answers do not use your AI messages.',
    points: [
      { icon: 'save', title: 'Save once' },
      { icon: 'translate', title: 'Translate' },
      { icon: 'sync', title: 'Reuse' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.smartAnswers,
    alt: 'Smart Answers in Linas AI',
  },
  {
    n: '06',
    navLabel: 'Smart Follow-Up',
    kicker: 'SMART FOLLOW-UP',
    title: 'Bring customers back.',
    body: 'Choose the channel, timing and goal. Linas follows up automatically when an interested customer goes quiet.',
    points: [
      { icon: 'pause', title: 'Goes quiet' },
      { icon: 'clock', title: 'Wait' },
      { icon: 'send', title: 'Follow up' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.smartFollowUp,
    alt: 'Smart Follow-Up settings',
  },
  {
    n: '07',
    navLabel: 'Integrations',
    kicker: 'INTEGRATIONS',
    title: 'Connect every channel.',
    body: 'Connect Instagram, Facebook, WhatsApp, TikTok and Web Chat, then control messages and comments.',
    points: [
      { icon: 'link', title: 'Connect' },
      { icon: 'check', title: 'Verify' },
      { icon: 'chat', title: 'Reply' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.integrations,
    alt: 'Channel integrations in Linas AI',
  },
  {
    n: '08',
    navLabel: 'Live Chat',
    kicker: 'LIVE CHAT CONVERSATION',
    title: 'Watch and take over.',
    body: 'See every conversation, take over from AI, assign a teammate and return the chat to AI without losing context.',
    points: [
      { icon: 'spark', title: 'AI replies' },
      { icon: 'hand', title: 'Take over' },
      { icon: 'user', title: 'Assign' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.liveChat,
    alt: 'Live Chat takeover in Linas AI',
  },
  {
    n: '09',
    navLabel: 'Requests',
    kicker: 'REQUESTS',
    title: 'Turn chats into work.',
    body: 'Turn orders, appointments and other requests into work you can assign, print and move from New to Done.',
    points: [
      { icon: 'doc', title: 'Capture' },
      { icon: 'user', title: 'Assign' },
      { icon: 'check', title: 'Complete' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.requests,
    alt: 'Requests board in Linas AI',
  },
  {
    n: '10',
    navLabel: 'Users',
    kicker: 'USERS & PERMISSIONS',
    title: 'Work as a team.',
    body: 'Add teammates, set roles and permissions, and decide exactly what each person can access.',
    points: [
      { icon: 'users', title: 'Invite' },
      { icon: 'lock', title: 'Set access' },
      { icon: 'user', title: 'Assign' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.users,
    alt: 'Users and permissions in Linas AI',
  },
  {
    n: '11',
    navLabel: 'Subscription',
    kicker: 'SUBSCRIPTION & MESSAGES',
    title: 'Control your capacity.',
    body: 'See your plan and included AI messages each month, compare upgrades and add more when needed.',
    points: [
      { icon: 'coin', title: 'Check' },
      { icon: 'compare', title: 'Compare' },
      { icon: 'upgrade', title: 'Upgrade' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.subscription,
    alt: 'Subscription and messages in Linas AI',
  },
  {
    n: '12',
    navLabel: 'Settings',
    kicker: 'SETTINGS',
    title: 'Make the app yours.',
    body: 'Change your name, email, language, notifications, appearance and legal or account preferences.',
    points: [
      { icon: 'user', title: 'Personalize' },
      { icon: 'save', title: 'Save' },
      { icon: 'sync', title: 'Sync' },
    ],
    image: LANDING_ASSETS.howItWorksScreens.settings,
    alt: 'Settings in Linas AI',
  },
];
